// extracted by mini-css-extract-plugin
module.exports = {"chart":"style-module__chart___1CCh4"};